export const SET_PRINT_MODE = 'SET_PRINT_MODE';
export const RESET_PRINT_MODE = 'RESET_PRINT_MODE';
export const PRINT_MODE_MODAL_STATUS = 'PRINT_MODE_MODAL_STATUS'; // NEW

